/* global Vue, TRAVEL_TYPES, TRAVEL_IDEAS */

import Card from './components/Card'
import LoadMore from './components/LoadMore'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'

const i18n = CreateI18n(messagesSpecific)

const TravelIdeasApp = Vue.createApp({
  name: 'TravelIdeasApp',
  components: { Card, LoadMore },
  template: '#travel-ideas-app-template',

  setup () {
    const filter = Vue.ref('all')
    const numberOfCards2show = Vue.ref(6)
    const addNoCards = 6

    const filteredTravelIdeas = Vue.computed(() => TRAVEL_IDEAS.filter(idea => {
      if (filter.value === 'all') return true
      return idea.traveltype === filter.value
    }))

    const travelType = (id) => (TRAVEL_TYPES.find(t => t.id === id)).title

    return {
      filter,
      numberOfCards2show,
      addNoCards,
      travelType,
      TRAVEL_TYPES,
      filteredTravelIdeas,
    }
  },
})

const appElement = document.getElementById('travel-ideas-app')

if (appElement) {
  TravelIdeasApp.use(i18n)
  TravelIdeasApp.mount(appElement)
}
